import {
  FaBookOpen,
  FaDownload,
  FaCheckCircle,
  FaMoneyBillWave
} from "react-icons/fa";

import "../styles/whyChooseUs.css";

function WhyChooseUs() {
  return (
    <section className="why-section">

      <div className="section-header">
        <h2>Why Choose CompExams?</h2>

        <p>
          Everything you need to prepare for your
          examinations in one place.
        </p>
      </div>

      <div className="why-grid">

        <div className="why-card">
          <FaBookOpen className="why-icon" />

          <h3>Thousands of Papers</h3>

          <p>
            Access a growing collection of past
            papers, CATs and examination materials.
          </p>
        </div>

        <div className="why-card">
          <FaDownload className="why-icon" />

          <h3>Instant Downloads</h3>

          <p>
            Download exam papers quickly and
            securely whenever you need them.
          </p>
        </div>

        <div className="why-card">
          <FaCheckCircle className="why-icon" />

          <h3>Verified Content</h3>

          <p>
            Carefully organized examination papers
            from trusted institutions.
          </p>
        </div>

        <div className="why-card">
          <FaMoneyBillWave className="why-icon" />

          <h3>Affordable Prices</h3>

          <p>
            Access free papers and premium content
            at student-friendly prices.
          </p>
        </div>

      </div>

    </section>
  );
}

export default WhyChooseUs;